import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  headerWrapper: {
    zIndex: theme.zIndex.drawer + 1,
    width: '100vw',
    height: 80,
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    transition: 'background-color .3s, border-color .3s',
    backgroundColor: 'inherit',
    borderColor: 'inherit',
    fontFamily: theme.gh_vars.circular,
  },
  headerContent: {
    width: '100%',
    maxWidth: theme.gh_vars.maxWidth,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 3),
    position: 'relative',
    zIndex: 40,
  },
  headerLeft: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    zIndex: 40,
    width: '100%',
    height: '100%',
  },
  headerCenter: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 40,
  },
  headerRight: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    zIndex: 40,
    width: '100%',
    height: '100%',
    gap: theme.spacing(4),
  },
  headerMenuToggle: {
    [theme.breakpoints.up('md')]: {
      display: 'none !important',
    }
  },
  headerMenu: {
    listStyleType: 'none',
    display: 'flex',
    margin: 0,
    padding: 0,
    zIndex: 40,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    }
  },
  headerMenuButton: {
    backgroundColor: theme.palette.tertiary.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  headerMenuItem: {
    position: 'relative',
    '& a': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: theme.spacing(1, 2),
      margin: theme.spacing(0, 1),
      position: 'relative',
      textDecoration: 'none',
      color: theme.palette.common.black,
      fontSize: 16,
      whiteSpace: 'nowrap',
      height: '100%',
      '&:before': {
        display: 'block',
        content: '\' \'',
        height: 2,
        position: 'absolute',
        bottom: -2,
        background: theme.palette.common.black,
        transition: 'opacity 0.25s, left 0.25s, right 0.25s',
        left: '50%',
        right: '50%',
        opacity: 0,
      },
      '&:hover:before': {
        left: 0,
        opacity: 1,
      },
      '&:after': {
        display: 'block',
        content: '\' \'',
        height: 2,
        position: 'absolute',
        bottom: -2,
        background: theme.palette.common.black,
        transition: 'opacity 0.25s, left 0.25s, right 0.25s',
        left: '50%',
        right: '50%',
        opacity: 0,
      },
      '&:hover:after': {
        right: 2,
        opacity: 1,
      },
      
    },
    '&:hover': {
      'ul': {
        display: 'flex',
      },
    },
  },
  headerMenuItemActive: {
    '& a': {
      '&:before': {
        display: 'block',
        content: '\' \'',
        height: 2,
        position: 'absolute',
        bottom: -2,
        background: theme.palette.common.black,
        transition: 'opacity 0.25s, left 0.25s, right 0.25s',
        left: 0,
        right: '50%',
        opacity: 1,
      },
      '&:after': {
        display: 'block',
        content: '\' \'',
        height: 2,
        position: 'absolute',
        bottom: -2,
        background: theme.palette.common.black,
        transition: 'opacity 0.25s, left 0.25s, right 0.25s',
        left: '50%',
        right: 2,
        opacity: 1,
      },
    },
  },
  headerSubmenu: {
    position: 'absolute',
    top: '100%',
    left: 0,
    width: 'calc(100% + 40px)',
    listStyleType: 'none',
    display: 'none',
    flexDirection: 'column',
    margin: 0,
    padding: theme.spacing(2, 0),
    backgroundColor: theme.palette.common.white,
    '& a:hover': {
      textDecoration: 'underline',
    },
    '& a:before': {
      display: 'none',
    },
    '& a:after': {
      display: 'none',
    },
  },
  rightMenuAnchorIcon: {
    marginRight: theme.spacing(1),
    width: 18,
    height: 'auto',
  },
  dropdownWrapper: {
    position: 'relative',
    height: '100%',
  },
  dropdownItem: {
    position: 'absolute',
    top: 0,
    left: 0,
    transitionTimingFunction: 'ease !important',
    padding: theme.spacing(3),
  },
}));
